// extracted by mini-css-extract-plugin
export var actionButton = "_ny-0";
export var actionMenuContainer = "_ny-i";
export var bubble = "_ny-2";
export var bubbleActionMenu = "_ny-j";
export var bubbleContext = "_ny-6";
export var bubbleItems = "_ny-7";
export var customer = "_ny-3";
export var divider = "_ny-8";
export var fileList = "_ny-9";
export var hiddenComment = "_ny-o";
export var infoAbove = "_ny-a";
export var internal = "_ny-4";
export var lightActionButton = "_ny-1";
export var link = "_ny-b";
export var merchant = "_ny-5";
export var message = "_ny-c";
export var profilePicture = "_ny-e";
export var quillToolbarContainer = "_ny-f";
export var senderDate = "_ny-g";
export var senderDateCustomer = "_ny-h";
export var senderName = "_ny-d";
export var time = "_ny-k";
export var uploadedImage = "_ny-l";
export var username = "_ny-m";
export var xsmall = "_ny-n";